<template>
  <div>
    <h2>Geral</h2>
    <div class="row mb-4">
      <div class="col-12 col-md-4">
        <div class="form-group">
          <label for="contratante">Contratante</label>
          <input type="text" readonly class="form-control-plaintext" id="contratante" value="Dedé Santana">
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="form-group">
          <label for="sigla">Sigla</label>
          <input type="text" readonly class="form-control-plaintext" id="sigla" value="XPTO">
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="form-group">
          <label for="cnpj">CNPJ</label>
          <input type="text" readonly class="form-control-plaintext" id="senha" value="85.472.557/0001-88">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-4 mb-4">
        <h2>Endereço</h2>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="endereco">Endereço</label>
              <input type="text" class="form-control" id="endereco" placeholder="Rua, Av, Travessa" />
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="numero">Número</label>
              <input type="text" class="form-control" id="numero" />
            </div>
          </div>
          <div class="col-12 col-md-8">
            <div class="form-group">
              <label for="cep">CEP</label>
              <input type="text" class="form-control" id="cep" placeholder="00000-000" />
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="uf">UF</label>
              <select class="form-control" id="uf">
                <option value="">1</option>
                <option value="">2</option>
                <option value="">3</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-md-8">
            <div class="form-group">
              <label for="cidade">Cidade</label>
              <input type="text" class="form-control" id="cidade" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 mb-4">
        <h2>Responsável pela contratação</h2>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="nome-responsavel">Nome</label>
              <input type="text" class="form-control" id="nome-responsavel" />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label for="cargo-responsavel">Cargo</label>
              <input type="text" class="form-control" id="cargo-responsavel" />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label for="email-responsavel">E-mail</label>
              <input type="text" class="form-control" id="email-responsavel" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 mb-4">
        <h2>Período de contratação</h2>
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label for="dt-inicio">Data de início</label>
              <input type="text" class="form-control" id="dt-inicio" />
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="dt-inicio">Data de término</label>
              <input type="text" class="form-control" id="dt-inicio" />
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContaDadosContratuais'
}
</script>

<style scoped>

</style>
